
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"39","height":"39","rx":"19.5","fill":"#fff"}}),_c('path',{attrs:{"d":"M27.5 12h-15a2.502 2.502 0 00-2.5 2.5v11.25c0 1.379 1.121 2.5 2.5 2.5h3.75v3.281a.467.467 0 00.746.375l4.879-3.656H27.5c1.379 0 2.5-1.121 2.5-2.5V14.5c0-1.379-1.121-2.5-2.5-2.5zm1.25 13.75c0 .688-.563 1.25-1.25 1.25h-6.043l-.332.25-3.625 2.719V27h-5c-.688 0-1.25-.563-1.25-1.25V14.5c0-.688.563-1.25 1.25-1.25h15c.688 0 1.25.563 1.25 1.25v11.25z","fill":"#586E8C"}}),_c('path',{attrs:{"d":"M15.333 19.367a1.34 1.34 0 001.334-1.344 1.34 1.34 0 00-1.334-1.345A1.34 1.34 0 0014 18.023a1.34 1.34 0 001.333 1.344zm9.334 0A1.34 1.34 0 0026 18.023a1.34 1.34 0 00-1.333-1.345 1.34 1.34 0 00-1.334 1.345 1.34 1.34 0 001.334 1.344zm.666.672H24c-.367 0-.698.15-.94.391a3.073 3.073 0 011.565 2.299H26c.369 0 .667-.301.667-.673v-.672a1.34 1.34 0 00-1.334-1.345zm-5.333 0a2.342 2.342 0 002.333-2.353c0-1.3-1.043-2.352-2.333-2.352a2.342 2.342 0 00-2.333 2.352c0 1.3 1.043 2.353 2.333 2.353zm1.6.673h-.173a3.26 3.26 0 01-1.427.336c-.513 0-.992-.126-1.427-.336H18.4a2.41 2.41 0 00-2.4 2.42v.605c0 .557.448 1.008 1 1.008h6c.552 0 1-.451 1-1.008v-.605a2.41 2.41 0 00-2.4-2.42zm-4.66-.282a1.324 1.324 0 00-.94-.39h-1.333a1.34 1.34 0 00-1.334 1.344v.672c0 .372.298.672.667.672h1.373a3.081 3.081 0 011.566-2.298z","fill":"#586E8C"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"39","height":"39","rx":"19.5","stroke":"#E0E0E0"}})])
          )
        }
      }
    